// Pieces the Social page and New post share: the small segmented switch, a
// post's card (Bailey's ideas, what's due) and the favourites row
import React from 'react'
import { hapticTick } from '../../../../../_utils/haptics'
import { postFromFavourite, favouriteNames } from '../data/favourites'
import { postTheme } from '../render/render'
import Preview from './Preview'
import LazyPreview from './studio/LazyPreview'
import { ChevronRight, CloseIcon } from './icons'

export const Seg = ({ value, options, onChange, label }) => (
  <div className="sx-seg sx-seg--small" role="radiogroup" aria-label={label}>
    {options.map(o => (
      <button key={o.id} type="button" role="radio" aria-checked={value === o.id} className={`sx-seg-btn${value === o.id ? ' is-on' : ''}`} onClick={() => { if (value !== o.id) { hapticTick(); onChange(o.id) } }}>
        {o.label}
      </button>
    ))}
  </div>
)

// A card with a post's preview: stacked on a computer, side by side on a
// phone (so a week of ideas reads as a list, not a scroller)
export const PostCard = ({ post, theme, kind, title, why, onClick, thumb, tone }) => (
  <button type="button" className={`sx-card${tone ? ` is-${tone}` : ''}`} onClick={onClick}>
    <span className="sx-card-art">
      {thumb ? <img src={thumb} alt="" className={post.format === 'story' ? 'is-story' : ''} /> : <Preview post={post} theme={theme} />}
    </span>
    <span className="sx-card-text">
      {kind && <span className="sx-card-kind">{kind}</span>}
      <strong className="sx-card-title">{title}</strong>
      {why && <span className="sx-card-why">{why}</span>}
      <span className="sx-card-go" aria-hidden>Open<ChevronRight size={14} /></span>
    </span>
  </button>
)

// The salon's favourites, each a new post in a tap
export const FavouriteGrid = ({ favourites, kit, trade, brandColour, onPick, onRemove }) => (
  <div className="sx-fav-row">
    {favourites.map((fav) => {
      const post = postFromFavourite(fav, { trade, brandColour })
      const names = favouriteNames(fav, { brandColour })
      return (
        <div key={fav.id} className="sx-tpl-cell">
          <button type="button" className="sx-tpl" onClick={() => onPick(fav)}>
            <span className="sx-tpl-art"><LazyPreview post={post} theme={postTheme(post, { kit })} /></span>
            <span className="sx-tpl-name">{names.title}</span>
            <span className="sx-tpl-design">{names.design}</span>
          </button>
          {onRemove && (
            <button type="button" className="sx-tpl-fav is-remove" aria-label={`Take ${names.title} out of your favourites`} title="Take out of favourites" onClick={() => onRemove(fav)}>
              <CloseIcon size={13} />
            </button>
          )}
        </div>
      )
    })}
  </div>
)
